import script from "./PaymentAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentAlert.vue?vue&type=script&setup=true&lang=js"

import "./PaymentAlert.vue?vue&type=style&index=0&id=5bc25f97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc25f97"]])

export default __exports__